import React from 'react'

function Inputtt({ placeholder, value, label, onChange, suffixIcon, ...rest }) {
  return (
    <div className=' w-full'>
      {label && <label className=' text-[14px] mb-3 block'>{label}</label>}
      <div className='relative w-full flex items-center'>
        <input
          className={`w-full bg-[#F7F8FB] border outline-0 p-3 rounded-lg ${suffixIcon ? 'pr-12' : ''}`}
          placeholder={placeholder}
          value={value}
          required
          onChange={(e) => onChange(e.target.value)}
          {...rest}
        />
        {suffixIcon && (
          <div className='absolute right-0 p-2 flex items-center justify-center'>
            {suffixIcon}
          </div>
        )}
      </div>
    </div>
  )
}

export default Inputtt